import { IDimensionalityOption } from 'constants/businessTool';
import { IPersonalExpensesCategory } from 'services/calculations/personalExpenses/types';

import { IRow } from 'components/BusinessToolForm/Sections/FinancialPlan/PlannedExpenses/CostOfSalesForm/utils/form';
import { MONTHLY_EXPENSES_FORM_TYPES } from 'components/BusinessToolForm/Sections/FinancialPlan/PlannedExpenses/MonthlyExpensesForm/utils/form';
import { EXPENSE_COLUMN_NAMES } from 'components/BusinessToolForm/Sections/FinancialPlan/PlannedExpenses/utils/form';
import { IGlobalProductEntity, PRODUCT_NAMES } from 'components/BusinessToolForm/Sections/Global/general/products';

const categoryNames = Object.keys(MONTHLY_EXPENSES_FORM_TYPES).slice(0, 4);

export const createPersonalExpensesByCategoryRequestParam = (salariesArray: IRow[][]) => {
  return salariesArray.map((salary, index) => {
    const salaryExpense = {
      type: categoryNames[index],
      salariesForProductionStaff: salary[0][EXPENSE_COLUMN_NAMES.COLUMN_0],
      salariesForProductionStaffGrowthRate: salary[0][EXPENSE_COLUMN_NAMES.COLUMN_1],
      benefitsAndPayrollTaxes: salary[1][EXPENSE_COLUMN_NAMES.COLUMN_0],
      benefitsAndPayrollTaxesGrowthRate: salary[1][EXPENSE_COLUMN_NAMES.COLUMN_1],
    };
    return salaryExpense;
  });
};

export const createPersonalExpensesByProductRequestParam = (
  salariesArray: IRow[],
  products: IGlobalProductEntity[],
  unit: IDimensionalityOption,
  businessPlanId: string,
) => {
  const productSalariesArray = [];

  for (let i = 0; i < products.length; i++) {
    const expensesByProductBody = {
      productId: products[i][PRODUCT_NAMES.PRODUCT_ID],
      salariesForProductionStaff: Number(salariesArray[0][`column${i}`]),
      benefitsAndPayrollTaxes: Number(salariesArray[1][`column${i}`]),
      sumOfOtherExpenses: 0,
    };
    const params = {
      unit,
      businessPlanId,
      expensesByProductBody,
    };
    productSalariesArray.push(params);
  }
  return productSalariesArray;
};

export const createPersonalExpensesTable = (
  table: IRow[],
  calculatedSalaries: IPersonalExpensesCategory[],
  totalVariablePayroll: number,
  variableWeightedAvg: number,
  multiplier: number
) => {
  for (let i = 1; i < table.length; i++) {
    const salary =
      (Number(calculatedSalaries[i - 1].salariesForProductionStaff) + Number(calculatedSalaries[i - 1].benefitsAndPayrollTaxes)) * multiplier;
    table[i]['column2'] = salary || '';
    table[i]['column3'] = calculatedSalaries[i - 1].salariesForProductionStaffGrowthRate || '';
    table[i]['column1'] =
      table[i]['column0'] && table[i]['column2']
        ? (Number(table[i]['column2']) / Number(table[i]['column0'])).toFixed(2)
        : '';
  }

  table[0]['column1'] =
    table[0]['column0'] && totalVariablePayroll ? (totalVariablePayroll / Number(table[0]['column0'])).toFixed(2) : '';
  table[0]['column2'] = totalVariablePayroll || '';
  table[0]['column3'] = variableWeightedAvg || '';
  return table;
};

export const getUpdatedPersonalExpensesTotal = (
  personalExpenseTotal: IRow,
  totalMonthlyPayroll: string | number,
  totalAnnualExpGrowth: number,
) => {
  return {
    ...personalExpenseTotal,
    column1:
      personalExpenseTotal.column0 && totalMonthlyPayroll
        ? (Number(totalMonthlyPayroll) / Number(personalExpenseTotal.column0)).toFixed(2)
        : '',
    column2: totalMonthlyPayroll,
    column3: totalAnnualExpGrowth,
  };
};
